import React from 'react';

import { PageTitle } from '../../components';
import { Menu } from '..';



const MenuPage = () => {

  return (

    <div className='menu-page'>

      {/* Page Title */}
      <PageTitle title={'Menu'} page={'Menu'} />

      {/* Menu Section */}
      <Menu />

    </div>

  );

}

export default MenuPage;